import axios from "axios";
import { v4 } from "uuid";
import moment from "moment";
import ReactGA4 from "react-ga4";
import ReactGA, { EventArgs } from "react-ga";

const {
    REACT_APP_SHOP_URL,
} = process.env;

const sessionId = v4();

export const trackEvent = async (apiKey: string, data: any) => {
    await axios.post(`${REACT_APP_SHOP_URL}/api/v1/shop/client/analytics`, {
        apiKey,
        sessionId,
        pluginType: "protection",
        ...data,
    })
};

const getTimeOfDay = (startTime: string) => {
    const time = parseInt(startTime);
    if (time >= 12) {
      return "PM";
    }
    return "AM";
};

export const getReadableDate = (date: string) => {
    if (!date) return "";
  
    const time = date?.split("T")[1].split(":");
    return `${moment(date).format("MMMM Do YYYY")} at ${time[0]}:${
      time[1]
    } ${getTimeOfDay(time[0])}`;
};

export const isDaylightSavingTimeUK = () => {
    const now = new Date();
    const year = now.getFullYear();
  
    // Calculate the start and end dates of daylight saving time in the UK
    // Daylight saving time in the UK starts on the last Sunday of March at 1:00 AM
    const start = new Date(year, 2, 31 - (new Date(year, 2, 31).getDay() || 7), 1);
    // Daylight saving time in the UK ends on the last Sunday of October at 2:00 AM
    const end = new Date(year, 9, 31 - (new Date(year, 9, 31).getDay() || 7), 2);
  
    return now >= start && now < end;
  }

  
export const isUniversalAnalytics = (googleAnalyticsTrackingId: string) => {
    return googleAnalyticsTrackingId.startsWith("UA-");
  };
  
  export const isGA4Analytics = (googleAnalyticsTrackingId: string) => {
    return googleAnalyticsTrackingId.startsWith("G-");
  };
  
  export const initializeUniversalAnalytics = (
    googleAnalyticsTrackingId: string
  ) => {
    ReactGA.initialize(googleAnalyticsTrackingId);
    ReactGA.pageview(window.location.pathname + window.location.search);
  };
  
  export const initializeGA4Analytics = (googleAnalyticsTrackingId: string) => {
    let gaOptions = {};
  
    if (sessionId) {
      gaOptions = {
        cookieDomain: "auto",
        clientId: sessionId,
      };
    }
    ReactGA4.initialize(googleAnalyticsTrackingId, {
      gaOptions,
    });
    ReactGA4.send("pageview");
  };
  
  export const initializeGoogleAnalytics = (
    googleAnalyticsTrackingId: string[]
  ) => {
  
    if (Array.isArray(googleAnalyticsTrackingId)) {
      const uaIndex = googleAnalyticsTrackingId.findIndex((id) =>
        isUniversalAnalytics(id)
      );
      const ga4Index = googleAnalyticsTrackingId.findIndex((id) =>
        isGA4Analytics(id)
      );
  
      if (uaIndex !== -1) {
        initializeUniversalAnalytics(googleAnalyticsTrackingId[uaIndex]);
      }
  
      if (ga4Index !== -1) {
        initializeGA4Analytics(googleAnalyticsTrackingId[ga4Index]);
      }
    }
  };
  
  export const trackGAEvent = (
    googleAnalyticsTrackingId: string[],
    event: EventArgs
  ) => {
    if (Array.isArray(googleAnalyticsTrackingId)) {
      const uaIndex = googleAnalyticsTrackingId.findIndex((id) =>
        isUniversalAnalytics(id)
      );
      const ga4Index = googleAnalyticsTrackingId.findIndex((id) =>
        isGA4Analytics(id)
      );
      if (uaIndex !== -1) {
        ReactGA.event({
          ...event,
          nonInteraction: true,
        });
      }
  
      if (ga4Index !== -1) {
        ReactGA4.event({
          ...event,
          nonInteraction: true,
        });
      }
    }
  };
  